import axios from 'axios';
import { API_ROOT } from '@/config';
import { isLoggedIn, logoutUser } from '@/utils/authService';


axios.defaults.baseURL = API_ROOT;

// Intercept requests and adds authorization header if the user is logged in
axios.interceptors.request.use(
  (config) => {
    if (isLoggedIn() && (!config.url.includes('skylarkvdpuk.blob.core.windows.net'))) {
      config.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('auth_details')).token}`;
    }
    // console.log(config);
    return config;
  },
  error => Promise.reject(error),
);

// Logout user if we get a unauthorized(401) reply from server
axios.interceptors.response.use(
  response => response,

  (error) => {
    if (error.response.status === 401) {
        logoutUser();
        window.location.pathname = '/';
      }
    // }
    return Promise.reject(error);
  },
);

export default {
  userLogin(data) {
    const url = 'api/login/';
    return axios.post(url, data);
  },
  userAutoLogin(token) {
    const url = `api/auto_login/?alt=${token}`;
    return axios.get(url);
  },
  userLogout() {
    const url = 'api/logout/';
    return axios.post(url);
  },
  projectDetails() {
    const url = 'api/project/';
    return axios.get(url);
  },
  getPositionJSON(id) {
    const url = 'api/position/';
    return axios.get(url, {
      params: {
        subsection_data_id: id,
      },
    });
  },
  getSubsectionComments(id) {
    const url = 'api/comment/';
    return axios.get(url, {
      params: {
        subsection_data_id: id,
      },
    });
  },
  saveComment(data) {
    const url = 'api/comment/';
    return axios.post(
      url,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },
  deleteComments(commentId) {
    const url = `api/comment/${commentId}/`;
    return axios.delete(url);
  },
  exportVideo(id, start, end) {
    const url = 'api/export_data/';
    return axios.get(url, {
      params: {
        subsection_data_id: id,
        start,
        end,
      },
    });
  },
  pollExport(downloadId) {
    const url = 'api/poll_state/';
    return axios.get(url, {
      params: {
        download_id: downloadId,
      },
    });
  },
  downloadReport(id) {
    const url = 'api/report/';
    return axios.get(url, {
      params: {
        project_id: id,
      },
    });
  },
  updateComment(commentId, data) {
    const url = `api/comment/${commentId}/`;
    return axios.patch(url, data);
  },

  getCommentCategories() {
    const url = '/api/comment_category/';
    return axios.get(url);
  },

  downloadJSON(url) {
    return axios.get(url, { responseType: 'json' });
  },

  updateSubsection(sid, data) {
    const url = `api/project_subsection/${sid}/`;
    return axios.patch(url, { checklist_json: data });
  },

  // Reset Password
  resetPassword(data) {
    const url = '/api/reset_password/';
    return axios.put(url, data);
  },
};
